import { DocumentStatus } from '../models';

export const getStatusLabel = (status: DocumentStatus) => {
  switch (status) {
    case 'PENDING':
      return 'Pending Approval';
    case 'PUBLISHED':
      return 'Approved';
    case 'REJECTED':
      return 'Rejected';
    default:
      return status;
  }
};
